/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const OrderPendingBuySalePage = lazyLoad(
  () => import('./index'),
  module => module.OrderPendingBuySalePage
);
